export default "dist/ad5aa8a695c7b0e143f0fcd14c6cef8a.png";